module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-7.c74143b3.jpg";